export default "__VITE_ASSET__CnZRqiA6__"